<template>
  <aha-modal
    :no-margin-padding="true"
    :visible-overflow="true"
    :hideHeader="true"
    width="405px"
    @hide="$emit('hide')"
    v-if="isOpenModal"
  >
    <div class="p-6 relative pricing-container-v3 pricing-custom-modal">
      <div class="flex flex-row justify-end align-middle pb-1.5 modal-close">
        <aha-icon
          name="close"
          @click="$emit('hide')"
          width="16"
          height="16"
          viewBox="0 0 24 24"
        />
      </div>
      <div class="title-speak-to-us">
        {{ $i18nPresenter.t('Speak to Us') }}
      </div>
      <div>
        <form @submit.prevent="onSubmitForm">
          <div class="mt-5">
            <div class="font-bold mb-2">
              {{ $i18nPresenter.t('Email') }}:
            </div>
            <aha-input
              type="email"
              required
              v-model="formData.email"
              :placeholder="$i18nPresenter.t('Enter your email')"
            />
            <div v-if="!isValidWorkEmail" class="text-xs text-pink-100">
              {{ $i18nPresenter.t('Please enter a valid work email address') }}
            </div>
          </div>
          <div class="mt-5">
            <div class="font-bold mb-2">
              {{ $i18nPresenter.t('How many licenses will your team need?') }}
            </div>
            <aha-input
              type="number"
              required
              min="2"
              max="200"
              v-model="formData.quantity"
              :placeholder="$i18nPresenter.t('Enter your quantity')"
            />
          </div>
          <div class="mt-5">
            <div class="font-bold mb-2">
              {{ $i18nPresenter.t('Your request') }}:
            </div>
            <aha-textarea
              v-model="formData.message"
              class="text-area"
              :placeholder="$i18nPresenter.t('Enter your message')"
              :max-length="1000"
            />
          </div>
          <aha-button
            type="submit"
            class="w-full mt-4 submit-request"
            :disabled="submitting || !isValidForm"
            :submitting="submitting"
          >
            {{ $i18nPresenter.t('Submit') }}
          </aha-button>
          <div class="mt-3 text-center">
            {{ $i18nPresenter.t('We will contact you shortly') }}.
          </div>
        </form>
      </div>
    </div>
  </aha-modal>
</template>
<script >
import { mapActions, mapState } from 'vuex'
import PersonalEmailValidationMixin from '../common/PersonalEmailValidationMixin'

export default {
  mixins: [PersonalEmailValidationMixin],
  props: {
    isOpenModal: {
      type: Boolean,
      default: false,
    },
    email: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      submitting: false,
      formData: {
        email: this.email,
        quantity: 3,
        message: '',
      },
    }
  },

  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
    isValidForm() {
      return this.isValidWorkEmail
    },
  },
  methods: {
    ...mapActions(['hookCustomRequestAction']),
    onSubmitForm() {
      this.submitting = true
      this.createHookBulkPricing()
    },
    async createCustomRequest(payload) {
      const { email, quantity, message } = payload
      return this.hookCustomRequestAction({
        email: email || this.currentUser.email,
        message: message || '',
        quantity: quantity || 3,
      })
    },
  },
}
</script>

<style scoped lang="scss">
.pricing-custom-modal {
  padding-top: 50px !important;
}
.modal-close {
  right: 16px !important;
  top: 16px !important;
  position: absolute;
  width: 32px;
  height: 32px;
  color: #555;
  cursor: pointer;
  border: 0;

}
.title-speak-to-us {
  font-size: 20px;
  font-weight: bold;
  position: absolute;
  top: 28px;
}

</style>
